module.exports = __webpack_public_path__ + "img/medcube_2.2b233eeb.jpg";